import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) =>
  createStyles({
    title: { backgroundColor: '#000', color: '#fff', textAlign: 'center' },
    root: {
      padding: 10,
      width: 360,
      backgroundColor: theme.palette.background.paper,
    },
    paper: {
      width: '80%',
      maxHeight: 435,
    },
    wrapModal: {
      minWidth: 300,
      paddingTop: '0px !important',
      padding: 0,
    },
  })
);

function ConfirmationDialog({
  open,
  setOpen,
  actionOk,
  title,
  content,
  maxWidth = 'sm',
  isConfirmation = true,
  isHtml = false,
  closeOnConfirm = true,
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleCancel = () => {
    setOpen(false);
  };

  const handleOk = async () => {
    await actionOk();
    if (closeOnConfirm) setOpen(false);
  };

  return (
    <Dialog
      maxWidth={maxWidth}
      open={open}
      PaperProps={{
        style: {
          border: '1px solid #fff',
        },
      }}
    >
      <DialogContent className={classes.wrapModal}>
        {title && <DialogTitle className={classes.title}>{title}</DialogTitle>}
        {isHtml ? (
          <DialogContent
            dividers
            dangerouslySetInnerHTML={{ __html: content }}
            style={{ fontSize: 16 }}
          />
        ) : (
          <DialogContent dividers style={{ fontSize: 18 }}>
            {content}
          </DialogContent>
        )}
        <DialogActions>
          {isConfirmation ? (
            <>
              <Button autoFocus onClick={handleCancel} color="primary">
                {t('no')}
              </Button>
              <Button onClick={handleOk} color="primary">
                {t('yes')}
              </Button>
            </>
          ) : (
            <Button autoFocus onClick={handleOk} color="primary">
              {t('ok')}
            </Button>
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  actionOk: PropTypes.func.isRequired,
  isConfirmation: PropTypes.bool,
  isHtml: PropTypes.bool,
  closeOnConfirm: PropTypes.bool,
  maxWidth: PropTypes.string,
};

ConfirmationDialog.defaultProps = {
  isConfirmation: true,
  isHtml: false,
  closeOnConfirm: true,
  maxWidth: 'sm',
};

export default ConfirmationDialog;
